export enum DescriptionType {
  CollectiveDescriptionBody = 'collective-description-body',
  TeaserTooLong = 'teaser-too-long',

  Status = 'status',
  Registration = 'registration',

  Subtitle = 'subtitle',
  IncludedServices = 'included-services',
  LegalContact = 'legal-contact',
  TimeInformation = 'time-info',
  AdditionalServiceSuitableFor = 'suitable-for',
  AdditionalServiceRequirements = 'requirements-info',
  AdditionalServiceEquipment = 'equipment-info',
  GoodToKnow = 'good-to-know',
  AdditionalServiceArrivalInformation = 'arrival-info',
  AdditionalInformation = 'additional-info',
  AdditionalServicePriceInformation = 'price-info',
  Teaser = 'teaser',
  Venues = 'venues',
  MainDescription = 'main',
  Venues2 = 'venues-2',
  LegalContact2 = 'legalcontact-2',
  MainDescription2 = 'maindescription2',
  AdditionalServiceSuitableFor2 = 'additionalservice-suitable-for-2',
  AdditionalServiceRequirements2 = 'additionalservice-requirements-2',
  AdditionalServiceIncludedServices2 = 'additionalservice-included-services-2',
  AdditionalServiceEquipment2 = 'equipment-info-2',
  CurrentInformation = '—',
  AdditionalServiceFAQGoodToKnow = 'faq-good-to-know',
  Difficulty = 'difficulty',
  AdditionalServiceOpeningHours = '—',
  AdditionalServiceRentalEquipment = 'additionalservice-rental-equipment',
  AdditionalServiceMeetingPoint = '—',
  AdditionalServiceArrivalInformation2 = 'arrival-info-2',
  FeratelLocal = '—',
  AdditionalServicePriceInformation2 = 'additional-service-price-information',
  EventHeader = 'event-header',
  EventHeaderShort = 'event-header-short',
  VenueTextualInfo = 'venue-textual-info',
  VenueDescription = 'venue-description',
  Zusatzinfo = 'zusatzinfo',
  TerminStatus = 'termin-status',
}
